import { useFeatureAuth } from "@/services/backend/auth/hooks/use-feature-auth";
import { UserFeedbackButton } from "@/shared/components/domain/user-feedback/user-feedback-button";
import { Toaster } from "@/shared/components/ui/sonner";
import type { NavLinkElement } from "@/shared/layout/navigation/main-nav";
import {
  Content,
  Logo,
  MainNav,
  UserMenu,
} from "@/shared/layout/navigation/main-nav";
import { Search } from "./_components/search/search";

export default function Root() {
  const canAccessBaseData = useFeatureAuth("portal.baseData");
  const canAccessStats = useFeatureAuth("portal.stats");
  const navList: NavLinkElement[] = [
    { to: "/processes", label: "Prozesse" },
    { to: "/deliveries", label: "Lieferungen" },
    /*{ to: "/stats", label: "Statistik" },*/
    { to: "/base-data/companies", label: "Stammdaten" },
  ].filter((item) => {
    switch (item.to) {
      case "/stats":
        return canAccessStats;
      case "/base-data/customers":
        return canAccessBaseData;
      default:
        return true;
    }
  });

  return (
    <div>
      <div className="bg-background fixed z-50 w-full border-b">
        <div className="mx-4 flex h-16 items-center">
          <Logo />
          <MainNav className="mx-6" navList={navList} />
          <div className="ml-auto flex items-center space-x-4">
            <UserFeedbackButton />
            <Search />
            <UserMenu />
          </div>
        </div>
      </div>
      <div className="pt-16">
        <Content />
      </div>
      <Toaster />
    </div>
  );
}
